import "./ErrorPage.scss";
import "@mshop-ui/core-web-components/dist/ui-button";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import Tracking from "../uidispatcherapi/Tracking";
import { LogoutAction, SessionStore } from "../uidispatcherapi/SessionStore";
type Props = {
	error: any;
	errorInfo: any;
};
type State = {
	referenceCode: string;
};

class ErrorPage extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			referenceCode: SessionStore.getClientSessionId(),
		};
	}

	componentDidMount() {
		Tracking.trackStructuredEvent(
			"platform",
			"uidispatcher",
			"client.errorpage.display",
			{
				tags: {
					url: window.location.pathname,
					error: this.props.error,
					errorInfo: JSON.stringify(this.props.errorInfo),
					component: "ErrorPage",
				},
			},
			null,
			50,
			this.state.referenceCode,
		);
	}

	refresh: (...args: Array<any>) => any = function () {
		window.location.reload();
	};
	logout: (...args: Array<any>) => any = function () {
		LogoutAction.trigger();
	};

	render(): any {
		return (
			<div className="error-page">
				<div className="text-center">
					<img src="/ordercapture/uidispatcher/static/app/assets/images/error.png" alt="oops" />
					<div className="page-text">
						<h1>
							<FormattedMessage id="PL_SORRY_ERROR_OCCURRED" />
						</h1>
						<h5>
							<FormattedMessage id="PL_DESCRIPTION_ERROR_OCCURRED" />
						</h5>
						<h5>
							<FormattedMessage id="PL_DESCRIPTION_ERROR_REFERENCE_CODE" />
						</h5>
						<h5>
							<span>{this.state.referenceCode}</span>
						</h5>
					</div>
					<div className="error-page-buttons">
						<ui-button>
							<button data-variant="action" onClick={this.refresh}>
								<FormattedMessage id="PL_REFRESH_THE_PAGE" />
							</button>
						</ui-button>
						<ui-button>
							<button data-variant="action" onClick={this.logout}>
								<FormattedMessage id="PL_RETURN_TO_HOMEPAGE" />
							</button>
						</ui-button>
					</div>
				</div>
			</div>
		);
	}
}

export default ErrorPage;
